<template>
    <AppModal
        :title="$t('labels.arrival_declaration')"
        ref="modal"
    >
        <div class="modal-body">
            <FormGroup :label="$t('labels.warehouse')" :required="true">
                <Select
                    @update:modelValue="newWarehouse => warehouse = newWarehouse"
                    @update:search="search = $event"
                    :model-value="warehouse.id"
                    :selected-value="warehouse.name"
                    :options="warehousesOptions"
                    :has-search="true"
                    optionKey="id"
                />
            </FormGroup>
            <FormGroup :label="$t('labels.supplier')" :required="true">
                <Select
                    @update:modelValue="newSupplier => supplier = newSupplier"
                    :model-value="supplier.id"
                    :selected-value="supplier.name"
                    :options="suppliers"
                    optionKey="id"
                />
            </FormGroup>
            <FormGroup :label="$t('labels.currency')" :required="true">
                <Select
                    @update:modelValue="newCurrency => currency = newCurrency"
                    :model-value="currency.uuid"
                    :selected-value="currency.name"
                    :options="currencies"
                />
            </FormGroup>
            <FormGroup :label="$t('labels.rate')" :required="true">
                <Input v-model="currency.rate" type="number"/>
            </FormGroup>
        </div>
        <div class="modal-footer">
            <Button size="sm" color="indigo" @click="createArrivalDeclaration" :disabled="!warehouse.id || !supplier.id || !currency.uuid">
                <span>{{ $t('buttons.create') }}</span>
            </Button>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../components/new/modal/AppModal.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
import Select from '../../../../../components/new/form/select/AppSelect.vue';
import Button from '../../../../../components/new/button/AppButton.vue';
import { httpClient } from '../../../../../services/HttpClient';
export default {
    name: "CreateArrivalDeclarationModal",
    components: {
        FormGroup, Input, Button, Select, AppModal
    },
    emits: ['created'],
    data() {
        return {
            warehouse: {
                id: null,
                name: ''
            },
            supplier: {
                id: null,
                name: ''
            },
            currency: {
                uuid: null,
                name: '',
                rate: 0
            },
            warehouses: [],
            suppliers: [],
            search: '',
            currencies: []
        }
    },
    computed: {
        warehousesOptions() {
            return this.warehouses.reduce((options, warehouse) => {
                if (warehouse.name.toLowerCase().includes(this.search.toLowerCase())) {
                    options.push(warehouse);
                }
                return options;
            }, []);
        },
        mainCurrency() {
            return this.currencies.find(currency => currency.main);
        }
    },
    methods: {
        async show() {
            let promises = [];
            
            if (this.warehouses.length === 0) {
                promises.push(this.fetchWarehouses());
            }
            if (this.suppliers.length === 0) {
                promises.push(this.fetchSuppliers());
            }
            if (this.currencies.length === 0) {
                promises.push(this.fetchCurrencies());
            }
            
            await Promise.all(promises);

            if (this.warehouses.length && !this.warehouse.id) {
                this.warehouse = this.warehouses[0];
            }
            if (this.suppliers.length && !this.supplier.id) {
                this.supplier = this.suppliers[0];
            }
            if (this.currencies.length && !this.currency.uuid) {
                this.currency = this.mainCurrency;
            }

            this.$refs.modal.show();
        },
        async createArrivalDeclaration() {
            await httpClient.post('/management/arrival-declarations', {
                warehouse_id: this.warehouse.id,
                supplier_id: this.supplier.id,
                currency_uuid: this.currency.uuid,
                currency_rate: this.currency.rate
            }).then(() => {
                this.$emit('created');
                this.$refs.modal.hide();
            });
        },
        async fetchWarehouses() {
            await httpClient.get('/management/warehouses', {limit:0}).then((response) => {
                this.warehouses = response.data.data
            });
        },
        async fetchSuppliers() {
            await httpClient.get('/management/suppliers').then((response) => {
                this.suppliers = response.data.data
            });
        },
        async fetchCurrencies() {
            await httpClient.get('/list/currencies').then((response) => {
                this.currencies = response.data.data;
            });
        },
    }
}
</script>
